export const getSizesByWindow = (window) => {
  const originalWidth = 2;
  const originalHeight = 1.5;
  const roleHeight = changeWallHeight(originalHeight, window);
  const roleWidth = changeWallWidth(originalWidth, window);

  return [roleWidth, roleHeight, originalWidth, originalHeight];
};

export function changeWallHeight(morphParam, window) {
  morphParam = (morphParam - 1.43) * 2.5;

  return morphParam;
}

export function changeWallWidth(morphParam, window) {
  morphParam = (morphParam - 1) * 0.5555;

  return morphParam;
}

export function getPositionForEachWindow(config) {
  const { mountings, size, coeficient } = config;
  const bottomValue = -(size * coeficient) / 1.9;
  const amountWindows = parseInt(mountings) + 1;
  const spaceValue = (size * coeficient) / parseInt(amountWindows);

  let windows = [];
  let tempValue = parseFloat(bottomValue);

  for (let i = 0; i < mountings; i++) {
    tempValue = parseFloat(tempValue) + parseFloat(spaceValue);
    windows.push(parseFloat(tempValue));
  }

  return windows;
}

export function getWindowsConfigurations(config) {
  const { settings, mountings } = config;

  return mountings.map((mounting) => {
    return getPositionForEachWindow({
      size: settings.sizes[mounting.orientation],
      coeficient: settings.coeficients[mounting.orientation],
      mountings: parseInt(mounting.mount),
    });
  });
}
